import { render, staticRenderFns } from "./FeaturedContent1.vue?vue&type=template&id=ebefdf5a&scoped=true"
import script from "./FeaturedContent1.vue?vue&type=script&lang=js"
export * from "./FeaturedContent1.vue?vue&type=script&lang=js"
import style0 from "./FeaturedContent1.vue?vue&type=style&index=0&id=ebefdf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebefdf5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
